export var initState = {};
export default function (state, action) {
    return null;
}
